var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#3A86FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 8.9375V7.84375C11.125 7.47079 10.9768 7.1131 10.7131 6.84938C10.4494 6.58566 10.0917 6.4375 9.71875 6.4375H9.09375C8.96943 6.4375 8.8502 6.38811 8.76229 6.30021C8.67439 6.2123 8.625 6.09307 8.625 5.96875V5.34375C8.625 4.97079 8.47684 4.6131 8.21312 4.34938C7.9494 4.08566 7.59171 3.9375 7.21875 3.9375H6.4375M6.4375 9.25H9.5625M6.4375 10.5H8M7.375 3.9375H5.34375C5.085 3.9375 4.875 4.1475 4.875 4.40625V11.5937C4.875 11.8525 5.085 12.0625 5.34375 12.0625H10.6562C10.915 12.0625 11.125 11.8525 11.125 11.5937V7.6875C11.125 6.69294 10.7299 5.73911 10.0266 5.03585C9.32339 4.33259 8.36956 3.9375 7.375 3.9375Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusQuote);
export default __webpack_public_path__ + "static/media/status_quote.3988360addae29636b5a2968ca75d647.svg";
export { ForwardRef as ReactComponent };